
import LabeledContainer from "../../components/LabeledContainer";
import TickIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';


export default function LabeledContainerProduct({ product }) {

   const installableIcon = product.installable ? <TickIcon className="text-green-500" /> : <CancelIcon className="text-red-500" />;

   return <LabeledContainer label="Product" className="rounded-lg p-4">
      <div className="text-lg text-gray-600">
         {product.name}
      </div>
      <div className="text-sm text-gray-500">
         {product.description}
      </div>
      <div className="mt-4 mx-2">
         {
            product.composition?.map((item, index) => {

            const name = item.product?.name || '(Deleted product)';

            return <div key={index} className="flex items-center">
               <div className="text-gray-500">
                  {item.quantity} X
               </div>
               <div className="text-gray-600 ml-2">
                  {name}
               </div>
            </div>
         })
         }
      </div>
      {
         product.installable !== undefined && <div className="flex items-center text-sm mt-4">
            {installableIcon}
            <span className="ml-1 text-gray-600">INSTALLABLE</span>
         </div>
      }
   </LabeledContainer>
}